import React from 'react';
import './footer.css';
import mapleeLogo from '../assets/logo.svg';

const Footer = () => {
  return (
    <footer className="sf-footer" role="contentinfo">
      <div className="sf-footer__container">
        {/* Brand */}
        <div className="sf-footer__brand">
          <a href="/" className="sf-footer__logo-link" aria-label="Maplee Home">
            <img src={mapleeLogo} alt="Maplee" className="sf-footer__logo" />
          </a>
          <p className="sf-footer__desc">
            Discover the finest Canadian products and brands, sourced locally with care.
          </p>

          <div className="sf-footer__social">
            <a
              href="https://www.facebook.com/people/Maplee/61575832059090/"
              aria-label="Facebook"
              className="sf-social-btn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" strokeLinejoin="round"
                   className="sf-social-icn">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
            </a>

            <a
              href="https://www.instagram.com/mapleecanada/"
              aria-label="Instagram"
              className="sf-social-btn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" strokeLinejoin="round"
                   className="sf-social-icn">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <circle cx="17.5" cy="6.5" r="0.5"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Pages */}
        <nav className="sf-footer__col" aria-label="Main pages">
          <h3 className="sf-footer__title">Company</h3>
          <ul className="sf-footer__links">
            <li><a href="/about-us" className="sf-footer__link">About Us</a></li>
            <li><a href="/pop-up-events" className="sf-footer__link">Pop-Up Events</a></li>
            <li><a href="/montreal-pop-up" className="sf-footer__link">Popup Registration — Montreal</a></li>
            <li><a href="/toronto-pop-up" className="sf-footer__link">Popup Registration — Toronto</a></li>
            <li><a href="/vendor-info" className="sf-footer__link">Vendor Information</a></li>
          </ul>
        </nav>

        {/* My Account */}
        <nav className="sf-footer__col" aria-label="Account">
          <h3 className="sf-footer__title">MY ACCOUNT</h3>
          <ul className="sf-footer__links">
            <li>
              <a href="https://www.maplee.ca/account" className="sf-footer__link">
                Sign In / Manage Account
              </a>
            </li>
          </ul>
        </nav>

        {/* (Optional) Customer Service – leave placeholder for later */}
        <div className="sf-footer__col">
          <h3 className="sf-footer__title">CUSTOMER SERVICE</h3>
          <ul className="sf-footer__links">
            <li><a href="https://www.maplee.ca/" className="sf-footer__link">support@maplee.ca</a></li>
          </ul>
        </div>
      </div>

      <div className="sf-footer__bottom">
        Copyright © {new Date().getFullYear()} Maplee. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
